import i18n from "i18n";
import { ITeacher } from "../../features/Teachers";
import { API, IResponse, onDayDelay } from "./API";

export interface IFetchTeachersEntity {
  _id: number;
  _name: string;
  _noOfStudents: number;
  _schoolId: number;
  _teacherId: number;
  _city: string;
  _email?: string;
  _lastName: string;
  _mobileNumber: string | null;
  _noOfClasses: number;
  _schoolName: string;
  _status: number;
  _token: string;
  _userTypeId: number;
}

interface IFetchTeachersResponse extends IResponse {
  _entity: IFetchTeachersEntity[];
}

export interface IUpdateTeacherRequest {
  _id: number;
  _fullName: string;
  _email: string;
}

export interface ISendCredentials {
  _userId: number;
  _lang: "AR" | "EN";
}

export interface IAddTeacherRequest {
  records: Partial<ITeacher>[];
  sendEmail: boolean;
}

export type ErrorAddingTeacherEntity = string[];
type SuccessAddingTeacherEntity = any[];
interface IAddTeacherResponse extends IResponse {
  _entity: ErrorAddingTeacherEntity | SuccessAddingTeacherEntity;
}

const teachersServices = API.injectEndpoints({
  endpoints(build) {
    return {
      fetchTeachers: build.query<IFetchTeachersResponse, string>({
        query(schoolId) {
          return `hod/school/${schoolId}/teacher`;
        },
        providesTags: ["Teachers"],
        keepUnusedDataFor: onDayDelay,
      }),
      addTeacher: build.mutation<IAddTeacherResponse, IAddTeacherRequest>({
        query({ records, sendEmail }) {
          return {
            url: `hod/teacher`,
            method: "POST",
            body: {
              _emailLang: i18n.dir() === "ltr" ? "EN" : "AR",
              _sendEmail: sendEmail,
              _teachers: records.map((teacher) => ({
                _fullName: teacher.name,
                _email: teacher.email,
              })),
            },
          };
        },
        invalidatesTags: ["Teachers"],
      }),
      updateTeacher: build.mutation<IResponse, IUpdateTeacherRequest>({
        query(data) {
          return {
            url: `hod/teacher`,
            method: "PUT",
            body: data,
          };
        },
        invalidatesTags: ["Teachers"],
      }),
      deleteTeacher: build.mutation<IResponse, number>({
        query(teacherId) {
          return {
            url: `hod/teacher/${teacherId}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["Teachers"],
      }),
      sendCredentials: build.mutation<IResponse, ISendCredentials>({
        query(data) {
          return {
            url: `hod/teacher/send-pin`,
            method: "POST",
            body: data,
          };
        },
      }),
      fetchPassword: build.query<IResponse, number | undefined>({
        query(userId) {
          return `/hod/teacher/${userId}/pin`;
        },
      }),
    };
  },
});

export const {
  useFetchTeachersQuery,
  useAddTeacherMutation,
  useUpdateTeacherMutation,
  useDeleteTeacherMutation,
  useSendCredentialsMutation,
  useFetchPasswordQuery,
} = teachersServices;
